import Web3 from 'web3';
import Cookies from 'js-cookie';
import axios from 'axios';
import { properties } from './properties.js';
import { createRoot } from 'react-dom/client';
import i18n from './I18N/I18n.js'; 
import Swal from 'sweetalert2';
import * as pdfjsLib from "pdfjs-dist";
import { PinataSDK } from "pinata-web3";
import QRCode from "react-qr-code";

export async function renderMedia(file) {
  if (file?.type === "video") {
    return (
      <video width="250px" controls>
        <source src={file.url} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    );
  } else if (file?.type === "image") {
    return <img src={file.url} width="250px" alt="Media Content" />;
  }
  return null;
};

export const cargarIdiomaPreferido = async (cambiarIdioma) => {
  const idiomaGuardado = Cookies.get('idiomaPreferido');
  console.log('Idioma guardado:', idiomaGuardado);

  if (idiomaGuardado) {
    if (i18n) {
      await cambiarIdioma(idiomaGuardado);
      console.log('Idioma cambiado a:', idiomaGuardado);
    } else {
     
    }
  } else {
    console.error('No se encontró el idioma guardado en las cookies');
    await cambiarIdioma('es');
  }
};

export async function loadWeb3() {
  try {
    if (window.ethereum) {
      window.web3 = new Web3(window.ethereum);

      // Promesa principal de solicitud de cuentas
      const requestAccountsPromise = window.ethereum.request({ method: 'eth_requestAccounts' });

      // Promesa de timeout (30 segundos)
      const timeoutPromise = new Promise((_, reject) =>
        setTimeout(() => reject(new Error("Timeout: El usuario no respondió a MetaMask")), 10000)
      );

      // Usamos Promise.race para hacer que la promesa de MetaMask compita con el timeout
      const requestAccounts = await Promise.race([requestAccountsPromise, timeoutPromise]);

      const web3 = window.web3;
      const accounts = await web3.eth.getAccounts();
      return accounts[0]; // Devuelve la cuenta si MetaMask responde a tiempo

    } else if (window.web3) {
      // Caso en el que ya existe un proveedor de web3 (legacy dapp browsers)
      window.web3 = new Web3(window.web3.currentProvider);
      const web3 = window.web3;
      const accounts = await web3.eth.getAccounts();
      return accounts[0];
      
    } else {
      console.log("No se encontró un proveedor de Ethereum");
      return 0; // Retorna 0 si no hay web3 disponible
    }
  } catch (error) {
    // Manejamos los errores, incluyendo si se supera el tiempo de espera
    if (error.code === 4001) {
      console.log("El usuario no respondió a MetaMask dentro del tiempo límite.");
      return 0;
    } else if (error.message === "Timeout: El usuario no respondió a MetaMask") {
      console.log("El usuario cerró MetaMask sin iniciar sesión.");
      return 0;
    } else {
      console.error("Error al conectar con MetaMask:", error);
      return 0;
    }
    return 0; // En caso de error, devolver 0
  }
}

export async function checkFileType(url) {
  try {
    const response = await fetch(url, { method: "HEAD" });
    const contentType = response.headers.get("Content-Type");

    if (contentType.includes("application/pdf")) {
      // Si es un PDF, renderizamos la primera página del PDF como imagen
      return await renderPdfToImage(url);
    } else if (contentType.startsWith("video/")) {
      // Si es un video, retornamos un objeto indicando que es video
      return { type: "video", url };
    } else if (contentType.startsWith("image/")) {
      // Si es una imagen, retornamos un objeto indicando que es imagen
      return { type: "image", url };
    } else {
      throw new Error("Unsupported file type");
    }
  } catch (error) {
    console.error("Error fetching the file type:", error);
  }
}

export async function renderPdfToImage(pdfUrl) {
  try {
    const pdf = await pdfjsLib.getDocument(pdfUrl).promise;
    const page = await pdf.getPage(1);
    const scale = 1.5;
    const viewport = page.getViewport({ scale });

    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    canvas.height = viewport.height;
    canvas.width = viewport.width;

    const renderTask = page.render({ canvasContext: context, viewport });
    await renderTask.promise;

    const imageUrl = canvas.toDataURL("image/png");

    return { type: "image", url: imageUrl };
  } catch (error) {
    console.error("Error rendering PDF to image:", error);
  }
}

  export const logout = async () => {
    // Establece el bearer y el email como null
    const allCookies = Cookies.get(); // Obtiene todas las cookies
    Object.keys(allCookies).forEach(cookieName => Cookies.remove(cookieName)); 
    localStorage.clear();
  
    // Redirige al inicio
    window.location.href = "/";
  };


  export const apiPublicRequest = async (method, url, data) => {
    try {
      const response = await axios({
        method: method,
        url: url,
        data: data,
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response;
    } catch (error) {
      console.error("Error in API call:", error);
      
       
    }
  };

  export const apiSecuredRequest = async (method, url, data, bearer) => {
    try {
      const response = await axios({
        method: method,
        url: url,
        data: data,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${bearer}`
        },
        validateStatus: (status) => {
          return status < 500; // Acepta todos los códigos de estado menores a 500
      }
      });

       if(response.status == 408) {
        Swal.fire({
          title: `${i18n.t('sessionExpired')}`,
          confirmButtonText: `${i18n.t('continue')}`,
          confirmButtonColor: '#E94981',
          icon: 'info',
          iconColor: '#66C08B',
          width: '560px',
      });
      }
      return response;
    } catch (error) {
      console.error("Error in API call:", error);
      Swal.fire({
        title: `${i18n.t('errorOccurred')}`,
        confirmButtonText: `${i18n.t('continue')}`,
        confirmButtonColor: '#E94981',
        icon: 'info',
        iconColor: '#66C08B',
        width: '560px',
    });
     
    }
  };
  export const isUserOrWallet = async (email, bearerVar) => {
    let account;
        if (typeof email === 'undefined') {
          account = await loadWeb3();
        }else{
          account = 0
        }
        return account;
  }


  export const setBearer = async (email, bearerVar, account) => {

        
        if (account != 0) {
            try{
                let data = JSON.stringify({
                  walletDir: `${account}`,
                  
                });
                const isUserWallet = await apiSecuredRequest('post', `${properties.apiUrl}/certificat/api/usuario/getUserByWalletDir`, data, bearerVar);
                 if(isUserWallet.data.walletDir == account && typeof bearerVar ==='undefined') {
                       
                        let data = JSON.stringify({
                            "email": `${properties.appUser}`,
                            "password": `${properties.appPass}`
                        });
                        const bearerToken = await apiPublicRequest('post', `${properties.apiUrl}/certificat/api/usuario/login`, data)
                       
                        bearerVar = bearerToken.data.accessToken
                
                        window.ethereum.on('accountsChanged', function (accounts) {
                            // Time to reload your interface with accounts[0]!
                            Swal.fire({
                            title: `${i18n.t('accountChanged')}`,
                            icon: 'info',
                            showCancelButton: false,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "OK"
                            }).then((result) => {
                                if(result.isConfirmed){
                                window.location.href = "/"
                                }
                            })
                            window.location.href = "/"
                        })
                        return bearerVar;

                }else if(typeof bearerVar !=='undefined'){
                  return bearerVar;
  
                }
              }catch (err) {
                  if(email == null) {
                    Swal.fire({
                      title: `${i18n.t('connect')}`,
                      icon: 'error',
                      showCancelButton: false,
                      confirmButtonColor: '#3085d6',
                      confirmButtonText: 'Finish'
                    }).then((result) => {
                      if (result.isConfirmed) {
                        
                         window.location.href = `/`;
                        
                      }
                      
                    });
                  }
              }
        }else {
        
            if(typeof bearerVar === 'undefined'){
              Swal.fire({
                title: `${i18n.t('connect')}`,
                icon: 'error',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Finish'
              }).then((result) => {
                if (result.isConfirmed) {
                  
                  window.location.href = `/`;
                  
                }
                
              });
                
            }else{
                return bearerVar;
            }
        }
}

export const sendFileToIPFS = async (fileInput) => {
  try {

    const pinata = new PinataSDK({
      pinataJwt: properties.pinataBearer,
      pinataGateway: properties.pinataGateway,
    });

     
    const upload = await pinata.upload.file(fileInput);
    return upload;
  } catch (error) {
    console.log("Error sending File to IPFS: ")
    console.log(error)
}
}

export const imprimirQR = async (qrValue) => {
  // Crear una nueva ventana
   // Crear una nueva ventana
   const printWindow = window.open('', '_blank');
  
   // Generar el contenido HTML para la impresión
   printWindow.document.write(`
     <html>
       <head>
         <title>Imprimir QR</title>
         <style>
           /* Centramos el QR en la página de impresión */
           body, html {
             display: flex;
             justify-content: center;
             align-items: center;
             height: 100%;
             margin: 0;
           }
         </style>
       </head>
       <body>
         <div id="qr-container"></div>
       </body>
     </html>
   `);
 
   // Espera para asegurarse de que el contenido HTML esté listo
   setTimeout(() => {
     const qrContainer = printWindow.document.getElementById('qr-container');
     if (qrContainer) {
       // Usamos createRoot en lugar de ReactDOM.render
       const root = createRoot(qrContainer);
       root.render(<QRCode value={qrValue} size={200} />);
       
       // Esperar un momento para cargar el QR y luego imprimir
       setTimeout(() => {
         printWindow.print();
         printWindow.close();
       }, 500);
     }
   }, 500);
};



